import React from 'react';
import './Footer.css';
import logo from '../assets/logo-footer.png'; // ✅ adjust path if needed

import logoFooter from '../assets/logo-no-bg.png';

function Footer() {
  return (
    <footer className="footer">
      <div className=" w3-center">
        

      <div className=" w3-row " style={{
  color: '#aaa'}}>
        {/* Logo and company info */} 

      <img src={logoFooter} alt="" className="" width="100" />
                  
            <p className="w3-small">
              BESSCO POWER [PVT] LTD
            <br />
            AF-005-007, 1st Floor, Conscient One
            <br />
            Sector 109, Gurugram, Haryana 122006
           <br /> info@bessco.in
           </p>

          </div>


         

       

      </div>


      {/* Bottom line */}
      <div className="footer-bottom">
        <p>
          <a href="/privacy-policy" className="footer-link">Privacy Policy</a> &nbsp;|&nbsp;
          <a href="/terms" className="footer-link">Terms & Conditions</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
